import { CountUp } from 'countup.js';
import 'waypoints/lib/noframework.waypoints.min.js';

const NumberCounter = () => {

    const getNumberFormat = (locale) => {
    switch (locale) {
        case 'de-DE':
            return {
                separator: "'",
                decimal: ".",
            };

        case 'fr-FR':
            return {
                separator: " ",
                decimal: ",",
            };

        default:
            return {
                separator: ",",
                decimal: ".",
            };
    }
};

    function countStart() {

        const time = document.querySelector('.stats-columns');
        const duration = parseFloat(time?.getAttribute('time')) || 2;

        const counters = document.querySelectorAll('.js-count-up');

        counters.forEach((item) => {

            const value = Number(item.dataset.value);
            const locale = item.dataset.locale || 'en-GB';

            const roundedValue = Math.round(value * 100) / 100;
            const decimalPlaces = (roundedValue.toString().split('.')[1] || '').length;

            const format = getNumberFormat(locale);

            const options = {
                useEasing: true,
                useGrouping: true,
                separator: format.separator,
                decimal: format.decimal,
                decimalPlaces,
                duration,
            };

            const counter = new CountUp(item, roundedValue, options);
            counter.start();
        });
    }

    const el = document.querySelector('.stats-columns');

    if (el) {
        new Waypoint({
            element: el,
            handler: function () {
                countStart();
                // this.destroy();
            },
            offset: '50%'
        });
    }
};

export default NumberCounter;